import React, {Component} from 'react';
import PropTypes from 'prop-types';
import UpdateLabelMutation from '../../mutations/update_label_mutation';
import DeleteLabelMutation from '../../mutations/delete_label_mutation';
import {injectIntl} from 'react-intl';
import ColorsPicker from '../../components/colors_picker';
import constants from '../../constants';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import Util from '../../forecast-app/shared/util/util';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';

class SettingsLabelsLineItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: this.props.label.name ? this.props.label.name : '',
			color: this.props.label.color,
		};
	}

	handleLabelNameChange(e) {
		const value = e.target.value.replace(/ /g, '');
		this.setState({name: value});
	}

	handleLabelNameBlur() {
		Util.CommitMutation(UpdateLabelMutation, {
			id: this.props.label.id,
			name: this.state.name,
		});
	}

	handleKeyPressLabel(e) {
		if (e.key === 'Enter') {
			this.labelInput.blur();
		}
	}

	handleSelectColorChange(value) {
		Util.CommitMutation(
			UpdateLabelMutation,
			{
				id: this.props.label.id,
				color: value,
			},
			null,
			true,
			false
		);

		this.setState({color: value});
	}

	handleLabelDelete() {
		const onSuccess = () => {
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: 'label.has-been-deleted'})});
		};
		const callbackPositive = params => {
			Util.CommitMutation(
				DeleteLabelMutation,
				{
					id: this.props.label.id,
					companyId: this.props.companyId,
				},
				onSuccess,
				true,
				false
			);
		};
		showModal({
			type: MODAL_TYPE.GENERIC_DELETION_WARNING,
			deleteCallback: callbackPositive,
		});
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<tr className="label-row" data-cy="label-row">
				<td>
					<input
						data-cy={this.props.cy}
						ref={input => (this.labelInput = input)}
						type="text"
						value={this.state.name}
						onChange={this.handleLabelNameChange.bind(this)}
						onBlur={this.handleLabelNameBlur.bind(this)}
						onKeyPress={this.handleKeyPressLabel.bind(this)}
					/>
				</td>
				<td>
					<ColorsPicker value={this.props.label.color} colors={constants.colors} onColorSelect={this.handleSelectColorChange.bind(this)} isOldCompany={this.props.isOldCompany} />
				</td>
				<td>{this.props.label.occurrenceCount}</td>
				<td className="controls">
					<span onClick={this.handleLabelDelete.bind(this)} data-cy="delete-label-button" className="remove">
						{formatMessage({id: 'common.delete'})}
					</span>
				</td>
			</tr>
		);
	}
}

SettingsLabelsLineItem.propTypes = {
	label: PropTypes.object.isRequired,
};
export default injectIntl(SettingsLabelsLineItem);
